import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IEmailTemplate } from "../../utils/types/models";

export default createEntityReducer<IEmailTemplate>(Endpoint.EmailTemplates, Endpoint.EmailTemplatesList);
